import React from 'react'
import './nftComponent.css'

const Nft = (d) => {
    const [isSelected, setIsSelected] = React.useState(false)
    const handleSelect = (e) => {
        e.preventDefault()
        setIsSelected(!isSelected)
        d.onClickHandle()
    }
    return (
        <div className={isSelected ? 'nft-selected' : 'nft'}>
            <img
                src={d.imgSrc}
                alt={d.tokenIdentifier}
                onClick={handleSelect}
            />
        </div>
    )
}

export default Nft
